import { StoreDevtoolsModule } from '@ngrx/store-devtools';

export const devToolsModule = [
	StoreDevtoolsModule.instrument({
		maxAge: 25
	})
];
